document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (!button || !menu) return;

  const setMenuState = (isOpen) => {
    button.setAttribute('aria-expanded', String(isOpen));
    button.setAttribute(
      'aria-label',
      isOpen ? 'Uždaryti meniu' : 'Atidaryti meniu'
    );

    menu.hidden = !isOpen;

    document.body.classList.toggle('menu-open', isOpen);
  };

  button.addEventListener('click', () => {
    const isOpen =
      button.getAttribute('aria-expanded') === 'true';

    setMenuState(!isOpen);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const isOpen =
      button.getAttribute('aria-expanded') === 'true';

    if (!isOpen) return;

    setMenuState(false);
    button.focus();
  });
});

(() => {
  const start = () => {
    const states = new WeakMap();
    const videos = new Set();
    const tryPlay = (video, state) => {
      if (!state.visible || state.userPaused || document.hidden) return;
      const result = video.play();
      if (result && typeof result.catch === 'function') result.catch(() => {});
    };
    const pause = (video, state) => {
      if (video.paused) return;
      state.autoPausing = true;
      video.pause();
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        const state = states.get(video);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.05;
        if (state.visible) tryPlay(video, state);
        else pause(video, state);
      });
    }, { threshold: [0, 0.05] }) : null;
    const setup = (video) => {
      if (states.has(video)) return;
      const state = { visible: !observer, userPaused: false, autoPausing: false };
      states.set(video, state);
      videos.add(video);
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.addEventListener('pause', () => {
        if (state.autoPausing) state.autoPausing = false;
        else if (state.visible && !document.hidden) state.userPaused = true;
      });
      video.addEventListener('play', () => {
        state.userPaused = false;
        if (!state.visible || document.hidden) pause(video, state);
      });
      video.addEventListener('loadedmetadata', () => tryPlay(video, state));
      if (observer) observer.observe(video);
      else tryPlay(video, state);
    };
    const scan = (root) => {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      if (root.matches && root.matches('video')) setup(root);
      root.querySelectorAll('video').forEach(setup);
    };
    scan(document);
    new MutationObserver((changes) => {
      changes.forEach((change) => {
        change.addedNodes.forEach(scan);
        change.removedNodes.forEach((root) => {
          if (root.nodeType !== 1) return;
          const removed = root.matches('video') ? [root] : Array.from(root.querySelectorAll('video'));
          removed.forEach((video) => {
            if (video.isConnected) return;
            if (observer) observer.unobserve(video);
            videos.delete(video);
            states.delete(video);
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', () => {
      videos.forEach((video) => {
        const state = states.get(video);
        if (document.hidden) pause(video, state);
        else tryPlay(video, state);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
